import { SheetOrDialog } from '@sravni/cosago-react-library/lib/components';
import type { ComponentProps } from 'react';
import { useCallback, useEffect, useState } from 'react';

import type { TPreApprovalOfferStepData } from 'shared/types/TRankingService';

import { useGetDeliverySlotsMutation } from 'entities/preApprovals';

// eslint-disable-next-line boundaries/element-types
import { DeliveryForm } from 'features/DeliveryForm';

import { TEXTS } from './DeliveryStep.texts';

type Props = {
  offerData: TPreApprovalOfferStepData;
  onNext: () => void;
  onClose: () => void;
  onChangeEvent?: ComponentProps<typeof DeliveryForm>['onChangeEvent'];
  onSubmitEvent?: ComponentProps<typeof DeliveryForm>['onSubmitEvent'];
  onShowEvent?: ComponentProps<typeof DeliveryForm>['onShowEvent'];
};

export const DeliveryStep: FC<Props> = (props) => {
  const { onNext, onClose, offerData, onShowEvent, onChangeEvent, onSubmitEvent } = props;
  const { preApprovalOfferId } = offerData;
  const [trigger] = useGetDeliverySlotsMutation();
  const [isInitialized, setIsInitialized] = useState(false);

  const initializeSelectedDeliverySlotCheck = useCallback(async () => {
    const result = await trigger({ offerId: preApprovalOfferId || '' }).unwrap();
    if (result.selectedSlot) {
      onNext();
    } else {
      setIsInitialized(true);
    }
  }, [preApprovalOfferId, onNext, trigger]);

  useEffect(() => {
    initializeSelectedDeliverySlotCheck();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isInitialized) {
    return null;
  }

  return (
    <SheetOrDialog
      visible
      onClose={onClose}
    >
      <SheetOrDialog.Header
        title={TEXTS.title}
        subtitle={TEXTS.description}
      />
      <SheetOrDialog.Content>
        <DeliveryForm
          offerData={offerData}
          onFormSubmit={onNext}
          onShowEvent={onShowEvent}
          onChangeEvent={onChangeEvent}
          onSubmitEvent={onSubmitEvent}
        />
      </SheetOrDialog.Content>
    </SheetOrDialog>
  );
};
